module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/BANISHED_S01.ba79ae2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/BANISHED_S01.jpg
// module id = mTYf
// module chunks = 0